@if (loaded && message) {
<div class="message-builder-container">
  <div class="phone-container">
    @if (contentCreateMode === 'manual') { @if (message.wire.is_shown ===
    'true') {
    <phone
      [screen]="screen"
      [message]="message"
      [hasIWCU]="hasIWCU"
      [productGroup]="productGroup"
      [components]="journey.draft.components"
      [language]="journey.latestContent.language"
    ></phone>
    } @if ( message.type === 'MessageSender' && message.sms.is_shown === 'true'
    ) {
    <div class="bubble" dir="auto">
      {{ getSmsBody() }}
    </div>
    } } @if (contentCreateMode === 'focusAi') {
    <rn-focus-ai-preview
      [clientId]="currentClient.id"
      [productGroup]="productGroup"
      [language]="journey.latestContent.language"
      [message]="this.focusAiMessage"
      [errorMessage]="focusAiError"
      [feedback]="feedback"
      (feedbackChange)="onFeedbackChange($event)"
    ></rn-focus-ai-preview>
    }
  </div>
  <div class="messaging-panel arrow-left-center">
    <div class="card panel-default">
      @if (contentCreateMode === 'manual') {
      <div class="card-header">
        <div
          class="col-sm-12"
          [ngClass]="{
            'has-error':
              !messageGroup.controls['message_name'].valid &&
              messageGroup.controls['message_name'].dirty
          }"
        >
          <app-error-display
            [control]="messageGroup.controls['message_name']"
            [customErrorMessageProvider]="getTooltipData.bind(this)"
          >
          </app-error-display>
          <span class="fa fa-pencil"></span>
          <input
            type="text"
            trim="blur"
            [formControl]="messageGroup.controls['message_name']"
            id="message-nickname-input"
            style="color: inherit"
          />
        </div>
      </div>
      <div class="card-body">
        <form>
          <div class="form-group">
            <div>
              <label>Experience</label>
              <div class="btn-group pull-right">
                <div
                  class="btn btn-sm btn-default"
                  [(ngModel)]="message.wire.is_shown"
                  (ngModelChange)="toggleWire()"
                  name="wire_is_shown_on"
                  ngDefaultControl
                  btnRadio="true"
                >
                  On
                </div>
                <div
                  class="btn btn-sm btn-default"
                  [(ngModel)]="message.wire.is_shown"
                  (ngModelChange)="toggleWire()"
                  name="wire_is_shown_off"
                  ngDefaultControl
                  btnRadio="false"
                >
                  Off
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <div [class.hidden]="message.wire.is_shown === 'false'">
              <div>
                <label>Client Message Tag</label>
                <input
                  name="client_message-id"
                  class="form-control client_message_tag"
                  type="text"
                  [(ngModel)]="message.client_message_tag"
                />
              </div>
              @if (showOutcomeExpTypeDropdowns) {
              <div>
                <div class="select-required">
                  <label for="outcome-select">Outcome</label>
                  <app-error-display
                    [control]="outcomeCtl"
                    [customErrorMessageProvider]="getTooltipData.bind(this)"
                  >
                  </app-error-display>
                </div>
                <select
                  id="outcome-select"
                  class="form-control"
                  name="outcome-select"
                  [formControl]="outcomeCtl"
                >
                  <option
                    [value]="''"
                    [selected]="showOutcomeTypeDefaultOption(outcomeCtl)"
                  >
                    Select an Outcome
                  </option>
                  @for (outcome of outcomes; track outcome) {
                  <option
                    [value]="outcome.id"
                    [selected]="outcomeCtl?.value === outcome.id"
                  >
                    {{ outcome.title['en-us'] }}
                  </option>
                  }
                </select>
              </div>
              <div>
                <div class="select-required">
                  <label for="experience-type-select">Experience Type</label>
                  <app-error-display
                    [control]="experienceTypeCtl"
                    [customErrorMessageProvider]="getTooltipData.bind(this)"
                  >
                  </app-error-display>
                </div>
                <select
                  id="experience-type-select"
                  class="form-control"
                  name="experience-type-select"
                  [formControl]="experienceTypeCtl"
                >
                  <option
                    [value]="''"
                    [selected]="
                      showExperienceTypeDefaultOption(
                        outcomeCtl,
                        experienceTypeCtl
                      )
                    "
                  >
                    Select an Experience Type
                  </option>
                  @for (experienceType of experienceTypes; track experienceType)
                  {
                  <option
                    [value]="experienceType.id"
                    [selected]="experienceTypeCtl?.value === experienceType.id"
                  >
                    {{ experienceType.title['en-us'] }}
                  </option>
                  }
                </select>
              </div>
              } @if (!newFeed.enabled) {
              <div>
                <label i18n="Message brand label">Branding</label>
                <div>
                  <select
                    class="form-control wire_branding"
                    placeholder="brand name"
                    name="wire_brand"
                    [(ngModel)]="message.wire.branding"
                    (ngModelChange)="onBrandSelected($event)"
                  >
                    <option
                      [ngValue]="null"
                      i18n="Default option for message branding"
                    >
                      default
                    </option>
                    @for (brand of brands; track brand) {
                    <option [ngValue]="brand.asset_id">
                      {{ brand.shortname }}
                    </option>
                    }
                    <option
                      value="create"
                      i18n="Option to create a brand on the message builder"
                    >
                      Create Brand
                    </option>
                  </select>
                </div>
              </div>
              } @if (newFeed.enabled && !message.parent) {
              <br />
              <!-- Feed Message Level Branding -->
              <app-radio-btn
                (btnModelChange)="toggleMessageLevelBranding($event)"
                [(btnModel)]="messageLevelBranding"
                [btnLabel]="'Message Level Branding'"
                [btnName]="'has-message-level-branding'"
                [btnWidth]="'100%'"
                [btnDisplayTrueFirst]="true"
              ></app-radio-btn>
              @if (messageLevelBranding) {
              <div>
                <select
                  class="form-control wire_branding"
                  placeholder="brand name"
                  name="feed_brand"
                  [(ngModel)]="message.message_level_branding_text"
                  (ngModelChange)="onBrandSelected($event)"
                >
                  <option
                    [ngValue]="productGroup.id"
                    i18n="Default option for message branding"
                  >
                    default (from Product Group)
                  </option>
                  @for (brand of brands; track brand) {
                  <option
                    [ngValue]="brand.asset_id"
                    [selected]="
                      feedMessageLevelBrandingCtl?.value?.brand_name ===
                      brand.shortname
                    "
                  >
                    {{ brand.shortname }}
                  </option>
                  }
                  <option
                    value="create"
                    i18n="Option to create a brand on the message builder"
                  >
                    Create Brand
                  </option>
                </select>
              </div>
              }
              <!-- FDIC Enabled & only for MessageSender aka no parent property -->
              @if (fdicEnabled && !message.parent) {
              <div>
                <label i18n="Message Level FIDC Signage" for="fdic-select"
                  >Message Level FDIC Signage</label
                >
                <select
                  class="form-control"
                  id="fdic-select"
                  name="fdic"
                  [(ngModel)]="message.fdic"
                >
                  <option
                    [ngValue]="null"
                    i18n="Default option to not display FDIC signage"
                  >
                    Do not display
                  </option>
                  <option
                    value="fdic-insured"
                    id="fdic-insured-option"
                    i18n="Option to display FDIC-insured signage"
                  >
                    Display FDIC-insured signage
                  </option>
                  <option
                    value="non-deposit"
                    i18n="Option to display non deposit signage"
                  >
                    Display non-deposit signage
                  </option>
                  ks
                </select>
              </div>
              } } @if (!newFeed.enabled) {
              <div>
                <app-radio-btn
                  [btnLabel]="'Display Banner'"
                  [btnName]="'show-banner'"
                  [(btnModel)]="message.wire.show_banner"
                  [btnWidth]="'100%'"
                  [btnDisplayTrueFirst]="true"
                ></app-radio-btn>
              </div>
              }
              <br />
              <hr />
              <div [ngClass]="{ 'has-error': isContentOrMediaMissingError }">
                @if (!message.wire.media_type) {
                <div>
                  <div class="d-flex justify-content-center">
                    <div class="btn btn-primary" (click)="addMediaAsset()">
                      <span class="icon icon-left"
                        ><i class="fa fa-plus-circle"></i
                      ></span>
                      <span
                        i18n="Link for adding an image or video to a message"
                        >Add Image or Video</span
                      >
                    </div>
                  </div>
                </div>
                } @if ( message.wire.media_type === 'image' ||
                message.wire.media_type === 'brand' || message.wire.media_type
                === 'video' ) {
                <div class="message-media">
                  <div>
                    <label i18n="Message brand label">Image or Video</label
                    ><i
                      id="remove-media-icon"
                      class="fa fa-minus-circle pull-right delete-action"
                      (click)="removeMediaAsset()"
                    ></i>
                  </div>
                  <div class="media-info-section">
                    <div class="media-info media-preview">
                      @if ( message.wire.media_type === 'image' ||
                      message.wire.media_type === 'brand' ) {
                      <img src="{{ message.wire.image_url }}" />
                      } @if ( message.wire.media_type === 'video' &&
                      message.wire['video_url'] ) {
                      <div class="video">
                        <app-video
                          [videoUrl]="message.wire['video_url']"
                        ></app-video>
                      </div>
                      }
                    </div>
                    <div class="media-info media-url">
                      @if ( message.wire.media_type === 'image' ||
                      message.wire.media_type === 'brand' ) {
                      <div>
                        <label i18n="Image URL label">Image URL</label>
                        <div id="wire-image-url">
                          {{ message.wire.image_url }}
                        </div>
                      </div>
                      } @if (message.wire.media_type === 'video') {
                      <div>
                        <label i18n="Video URL label">Video URL</label>
                        <div id="wire-video-url">
                          {{ message.wire.video_url }}
                        </div>
                      </div>
                      }
                    </div>
                  </div>
                </div>
                } @if (isContentOrMediaMissingError) {
                <app-error-display
                  [control]="messageGroup.controls['message_text']"
                  [customMessage]="contentOrMediaRequiredMessage"
                >
                </app-error-display>
                }
              </div>
              <hr />
              <!-- Open Content Pro section -->
              @if (newFeed.enabled && contentProEnabled) {
              <div
                data-testid="contentpro-btn"
                class="focus-ai-button"
                (click)="switchToFocusAiMode()"
              >
                @if (message.wire.ai_generated) {
                <div
                  class="focus-ai-button-content d-flex justify-content-center align-items-center"
                >
                  <i class="fa-solid fa-sparkles fa-xl mr-2"></i>
                  <div class="focus-ai-generated-button">
                    <span class="focus-ai-black-text">
                      This content was originally generated with Content Pro.
                    </span>
                    <div>Generate new content.</div>
                  </div>
                </div>
                } @else {
                <div class="d-flex justify-content-center align-items-center">
                  <i class="fa-solid fa-sparkles fa-xl mr-2"></i>
                  Use Content Pro to create message content
                </div>
                }
              </div>
              }
              <!-- Message Content -->
              <label>Message Content</label>
              <rn-form-input-state-control
                [formReference]="messageGroup.controls['message_text']"
                [isError]="isContentOrMediaMissingError"
                [customMessage]="
                  isContentOrMediaMissingError
                    ? contentOrMediaRequiredMessage
                    : undefined
                "
                [showCharacterCount]="true"
                [totalLength]="wireOrFeedMessageTextLimit"
              >
                @if (message) {
                <!-- TODO: use reactive or template forms - not both. See: https://angular.io/api/forms/FormControlDirective#use-with-ngmodel -->
                <app-tiny-editor
                  class="tiny-editor-mentions"
                  [elementId]="'tiny-editor-message-wire-text'"
                  [formControl]="messageGroup.controls['message_text']"
                  [config]="tinyEditorConfig"
                  [isRawEditorEnabled]="this.showRawEditor"
                >
                </app-tiny-editor>
                }
              </rn-form-input-state-control>
              <div>use &#64; to get the dynamic fields.</div>
              <!-- Alternate Message Text -->
              <app-radio-btn
                (btnModelChange)="toggleAlternateMessageText($event)"
                [(btnModel)]="message.wire.is_alternate_message"
                [btnLabel]="'Alternate Message Text'"
                [btnName]="'has-alternate-message'"
                [btnWidth]="'100%'"
                [btnDisplayTrueFirst]="true"
              ></app-radio-btn>
              <div>
                This message will be sent to your users in the event there is an
                issue with the data for the personalized fields
              </div>
              <div class="clearfix"></div>
              <div style="position: relative; padding: 5px 0">
                <rn-form-input-state-control
                  [formReference]="
                    messageGroup.controls['alternate_message_text']
                  "
                  [showCharacterCount]="isAlternateMessageTextEnabled"
                  [totalLength]="wireOrFeedMessageTextLimit"
                >
                  @if (message.wire.is_alternate_message) {
                  <app-tiny-editor
                    class="tiny-editor-mentions"
                    [elementId]="'tiny-editor-alternate-message-text'"
                    [formControl]="
                      messageGroup.controls['alternate_message_text']
                    "
                    [isRawEditorEnabled]="this.showRawEditor"
                  >
                  </app-tiny-editor>
                  }
                </rn-form-input-state-control>
              </div>
              <hr />
              <div [formGroup]="actionFormArray">
                @if (newFeed.enabled && primaryAction) {
                <div class="actions" id="msg-action-0">
                  <message-builder-action
                    [actionInput]="primaryAction"
                    [i]="0"
                    [formReference]="actionFormArray.controls[0]"
                    [nextMoveUpIndex]="nextMoveUpActionIndex(primaryAction, 0)"
                    [nextMoveDownIndex]="
                      nextMoveDownActionIndex(primaryAction, 0)
                    "
                    [numberOfActions]="message.wire.actions.length"
                    [journey]="journey"
                    [productGroup]="productGroup"
                    [dynamicInputs]="dynamicInputs"
                    (delete)="deleteAction(primaryAction, 0)"
                    (moveUp)="(null)"
                    (moveDown)="(null)"
                  >
                  </message-builder-action>
                  <div>use &#64; to get the dynamic fields.</div>
                  <hr />
                </div>
                } @if (newFeed.enabled && isAbleToAddPrimaryAction) {
                <div class="add-actions" id="primary-action-elements-list">
                  <label
                    ><i class="fa fa-plus-circle" aria-hidden="true"></i>
                    Primary Action Element</label
                  >
                  <div
                    class="btn btn-lg btn-primary"
                    (click)="addPrimaryAction('hyperlink')"
                    id="add-primary-link-element-btn"
                    matTooltip="Link"
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                  >
                    <i class="fa fa-link" aria-hidden="true"></i>
                  </div>
                  <div
                    class="btn btn-lg btn-primary"
                    (click)="addPrimaryAction('call')"
                    id="add-primary-call-element-btn"
                    matTooltip="Click to Call"
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                  >
                    <i class="fa fa-phone" aria-hidden="true"></i>
                  </div>
                  <div
                    class="btn btn-lg btn-primary"
                    (click)="addPrimaryAction('email')"
                    id="add-primary-email-element-btn"
                    matTooltip="Click to Email"
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                  >
                    <img src="/assets/icons/icon-EmailAction.png" />
                  </div>
                  <div
                    class="btn btn-lg btn-primary response-btn"
                    (click)="addPrimaryAction('message')"
                    id="add-primary-message-element-btn"
                    matTooltip="Message Branch"
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                  >
                    <i class="fa fa-code-fork turn90" aria-hidden="true"></i>
                  </div>
                  @if (twoWayService.showTwoWay()) {
                  <div
                    class="btn btn-lg btn-primary response-btn"
                    (click)="addPrimaryAction('two_way')"
                    id="add-primary-two-way-element-btn"
                    [matTooltip]="tooltipMessage"
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                  >
                    <i class="fa fa-comments" aria-hidden="true"></i>
                  </div>
                  }
                  <div
                    class="btn btn-lg btn-primary response-btn"
                    (click)="addPrimaryAction('form_info_capture')"
                    id="add-primary-power-up-element-btn"
                    matTooltip="Power-Ups"
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                    [style.opacity]="!currentClient.powerups_enabled ? 0.5 : 1"
                    [style.pointer-events]="
                      !currentClient.powerups_enabled ? 'none' : 'auto'
                    "
                  >
                    <i class="fa fa-wpforms"></i>
                  </div>
                  @if (hasIWCU) {
                  <div
                    class="btn btn-lg btn-primary"
                    [class.disabled]="!userCanAddIWCUAction()"
                    (click)="addPrimaryAction('consent_upgrade')"
                    id="add-primary-consent-upgrade-element-btn"
                    [matTooltip]="
                      newFeed.enabled
                        ? 'In Feed Consent Upgrade'
                        : 'In Wire Consent Upgrade'
                    "
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                  >
                    <i class="fa fa-angle-double-up" aria-hidden="true"></i>
                  </div>
                  } @if (newFeed.enabled) {
                  <div
                    class="btn btn-lg btn-primary"
                    [class.disabled]="!contactCardFile"
                    (click)="addPrimaryAction('contact_card')"
                    id="add-primary-contact-card-element-btn"
                    [matTooltip]="'Contact Card Download'"
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                  >
                    <i
                      class="fa-regular fa-address-card"
                      aria-hidden="true"
                    ></i>
                  </div>
                  }
                  <hr />
                </div>
                } @if (!newFeed.enabled) { @for ( action of
                message.wire.actions; track actionById(i, action); let i =
                $index) {
                <div class="actions" id="msg-action-{{ i }}">
                  @if (action.type !== 'disclaimer') {
                  <message-builder-action
                    [actionInput]="action"
                    [formReference]="actionFormArray.controls[i]"
                    [i]="i"
                    [nextMoveUpIndex]="nextMoveUpActionIndex(action, i)"
                    [nextMoveDownIndex]="nextMoveDownActionIndex(action, i)"
                    [numberOfActions]="message.wire.actions.length"
                    [journey]="journey"
                    [productGroup]="productGroup"
                    [dynamicInputs]="dynamicInputs"
                    (delete)="deleteAction(action, i)"
                    (moveUp)="moveActionUp(action, i)"
                    (moveDown)="moveActionDown(action, i)"
                  >
                  </message-builder-action>
                  <div>use &#64; to get the dynamic fields.</div>
                  <hr />
                  }
                </div>
                } } @if (newFeed.enabled) { @for ( action of
                message.wire.actions; track actionById(i, action); let i =
                $index) { @if ( !action.primary &&
                isActionTypeSupportedInNewFeed(action.type) && action.type !==
                'disclaimer' ) {
                <div class="actions" id="msg-action-{{ i }}">
                  <message-builder-action
                    [actionInput]="action"
                    [formReference]="actionFormArray.controls[i]"
                    [i]="i"
                    [nextMoveUpIndex]="nextMoveUpActionIndex(action, i)"
                    [nextMoveDownIndex]="nextMoveDownActionIndex(action, i)"
                    [numberOfActions]="message.wire.actions.length"
                    [journey]="journey"
                    [productGroup]="productGroup"
                    [dynamicInputs]="dynamicInputs"
                    (delete)="deleteAction(action, i)"
                    (moveUp)="moveActionUp(action, i)"
                    (moveDown)="moveActionDown(action, i)"
                  >
                  </message-builder-action>
                  <div>use &#64; to get the dynamic fields.</div>
                  <hr />
                </div>
                } } }
                <div class="add-actions" id="non-primary-action-elements-list">
                  <label
                    ><i class="fa fa-plus-circle" aria-hidden="true"></i>
                    {{
                      newFeed.enabled
                        ? 'Secondary Action Elements'
                        : 'Add message action'
                    }}</label
                  >
                  <div
                    class="btn btn-lg btn-primary"
                    (click)="addLinkElement()"
                    id="add-link-element-btn"
                    matTooltip="Link"
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                  >
                    <i class="fa fa-link" aria-hidden="true"></i>
                  </div>
                  <div
                    class="btn btn-lg btn-primary"
                    (click)="addCallElement()"
                    id="add-call-element-btn"
                    matTooltip="Click to Call"
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                  >
                    <i class="fa fa-phone" aria-hidden="true"></i>
                  </div>
                  <div
                    class="btn btn-lg btn-primary"
                    (click)="addEmailElement()"
                    id="add-email-element-btn"
                    matTooltip="Click to Email"
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                  >
                    <img src="/assets/icons/icon-EmailAction.png" />
                  </div>
                  <div
                    class="btn btn-lg btn-primary response-btn"
                    (click)="addMessageElement()"
                    id="add-message-element-btn"
                    matTooltip="Message Branch"
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                  >
                    <i class="fa fa-code-fork turn90" aria-hidden="true"></i>
                  </div>
                  <div
                    class="btn btn-lg btn-primary"
                    (click)="addCollapsibleElement()"
                    id="add-collapsible-element-btn"
                    matTooltip="Collapsible Section"
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                  >
                    <i class="fa re-collapsible" aria-hidden="true"></i>
                  </div>
                  @if (twoWayService.showTwoWay()) {
                  <div
                    class="btn btn-lg btn-primary response-btn"
                    (click)="addTwoWayElement()"
                    id="add-two-way-element-btn"
                    [matTooltip]="tooltipMessage"
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                  >
                    <i class="fa fa-comments" aria-hidden="true"></i>
                  </div>
                  }
                  <div
                    class="btn btn-lg btn-primary response-btn"
                    (click)="addPlaidElement()"
                    id="add-plaid-element-btn"
                    matTooltip="Plaid"
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                  >
                    <i class="fa fa-money" aria-hidden="true"></i>
                  </div>
                  @if ( featureService.checkFlag(featureFlags.apple_chat) &&
                  !newFeed.enabled ) {
                  <div
                    class="btn btn-lg btn-primary response-btn"
                    (click)="addAppleChatElement()"
                    id="add-apple-chat-element-btn"
                    matTooltip="Apple Chat"
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                  >
                    <i class="fa fa-apple"></i>
                  </div>
                  }
                  <div
                    class="btn btn-lg btn-primary response-btn"
                    (click)="addFormInfoCaptureElement()"
                    id="add-power-up-element-btn"
                    matTooltip="Power-Ups"
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                    [style.opacity]="!currentClient.powerups_enabled ? 0.5 : 1"
                    [style.pointer-events]="
                      !currentClient.powerups_enabled ? 'none' : 'auto'
                    "
                  >
                    <i class="fa fa-wpforms"></i>
                  </div>
                  @if (hasIWCU) {
                  <div
                    class="btn btn-lg btn-primary"
                    [class.disabled]="!userCanAddIWCUAction()"
                    (click)="addIWCUElement()"
                    id="add-consent-upgrade-element-btn"
                    [matTooltip]="
                      newFeed.enabled
                        ? 'In Feed Consent Upgrade'
                        : 'In Wire Consent Upgrade'
                    "
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                  >
                    <i class="fa fa-angle-double-up" aria-hidden="true"></i>
                  </div>
                  } @if (newFeed.enabled) {
                  <div
                    class="btn btn-lg btn-primary"
                    [class.disabled]="!contactCardFile"
                    (click)="addContactCardElement()"
                    id="add-contact-card-element-btn"
                    [matTooltip]="'Contact Card Download'"
                    matTooltipPosition="above"
                    matTooltipClass="actions-tooltip-style"
                  >
                    <i
                      class="fa-regular fa-address-card"
                      aria-hidden="true"
                    ></i>
                  </div>
                  }
                </div>
                <hr />
              </div>
            </div>
          </div>
          @if (isMsgLevelDisclaimerEnabled) {
          <br />
          <div class="form-group child-group" [formGroup]="actionFormArray">
            <label>Message Level Disclaimer</label>
            <div
              class="btn-group pull-right"
              btnRadioGroup
              [ngModel]="isDisclaimerOn"
              [ngModelOptions]="{ standalone: true }"
            >
              <div
                id="toggle-disclaimer-on"
                class="btn btn-sm btn-default"
                name="disclaimer-on"
                btnRadio="on"
                ngDefaultControl
                (click)="turnOnDisclaimer()"
              >
                On
              </div>
              <div
                id="toggle-disclaimer-off"
                class="btn btn-sm btn-default"
                name="disclaimer-off"
                btnRadio="off"
                (click)="turnOffDisclaimer()"
              >
                Off
              </div>
            </div>
            @if (disclaimerAction && isDisclaimerOn === 'on') {
            <div id="message-disclaimer">
              <p>
                Changes made here will not apply to global disclaimer.
                <strong
                  >Character limit:
                  {{ CharacterLimits.MessageLevelDisclaimerCharLimit }}</strong
                >
              </p>
              <message-builder-action
                [actionInput]="disclaimerAction"
                [formReference]="
                  actionFormArray.controls[message.wire.actions.length - 1]
                "
                [i]="message.wire.actions.length - 1"
                [nextMoveUpIndex]="-1"
                [nextMoveDownIndex]="message.wire.actions.length"
                [numberOfActions]="message.wire.actions.length"
                [journey]="journey"
                [productGroup]="productGroup"
                [dynamicInputs]="[]"
                (delete)="(null)"
                (moveUp)="(null)"
                (moveDown)="(null)"
              >
              </message-builder-action>
              <div class="disclaimer-helper">
                <p>
                  <span
                    >{{
                      CharacterLimits.MessageLevelDisclaimerCharLimit -
                        (disclaimerAction?.value?.length || 0)
                    }}
                  </span>
                  remaining characters
                </p>
                <p class="disclaimer-default-group-message">
                  Using disclaimer for
                  <strong>{{ productGroup.name }}</strong> by default.
                </p>
              </div>
            </div>
            }
            <div class="clearfix"></div>
          </div>
          } @if (newFeed.enabled && !message.parent) {
          <br />
          <div class="form-group">
            <div class="message_expiration">
              <label>Message Expiration</label>
              <div class="message_expiration_toggles pull-right">
                <div>
                  <div class="btn-group">
                    <div
                      name="type"
                      [formControl]="feedMessageExpirationTypeCtl"
                      class="btn btn-sm btn-default"
                      [(ngModel)]="feedMessageExpirationTypeCtl.value"
                      ngDefaultControl
                      btnRadio="custom"
                      id="message-expiration-on"
                      (click)="setMessageExpiration('custom')"
                    >
                      On
                    </div>
                    <div
                      name="type"
                      [formControl]="feedMessageExpirationTypeCtl"
                      class="btn btn-sm btn-default"
                      [(ngModel)]="feedMessageExpirationTypeCtl.value"
                      ngDefaultControl
                      btnRadio="none"
                      id="message-expiration-off"
                      (click)="setMessageExpiration('none')"
                    >
                      Off
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div>
                @if (isMessageExpirationType('custom')) {
                <div class="message_expiration_enabled">
                  <p>
                    Set the amount of time until this message is permanently
                    removed from a customer’s Feed.
                  </p>
                  <div class="d-flex input_container">
                    <input
                      name="amount"
                      id="number-days-weeks"
                      class="form-control input_number"
                      [formControl]="feedMessageExpirationAmountCtl"
                      placeholder="##"
                      type="number"
                      pattern="[0-9]*"
                      min="1"
                      max="99"
                      maxlength="2"
                      [ngClass]="{
                        invalid_input:
                          feedMessageExpirationAmountCtl.invalid &&
                          (feedMessageExpirationAmountCtl.dirty ||
                            feedMessageExpirationAmountCtl.touched)
                      }"
                    />
                    @if ( feedMessageExpirationAmountCtl.invalid &&
                    (feedMessageExpirationAmountCtl.dirty ||
                    feedMessageExpirationAmountCtl.touched) ) {
                    <i
                      id="invalid-icon"
                      class="fa fa-exclamation-circle invalid-icon"
                      [matTooltip]="
                        feedMessageExpirationAmountCtl.errors?.max
                          ? 'Entry cannot exceed 2 digits.'
                          : 'Value is required.'
                      "
                      matTooltipPosition="above"
                      matTooltipClass="tooltip"
                    >
                    </i>
                    }
                    <select
                      id="days-weeks-dropdown"
                      class="form-control days_weeks_select"
                      [formControl]="feedMessageExpirationUnitCtl"
                    >
                      @for (value of daysWeeks; track value) {
                      <option [value]="value" name="unit">
                        {{ value }}
                      </option>
                      }
                    </select>
                    <div>
                      <i
                        class="fa fa-question-circle question_mark_icon"
                        aria-hidden="true"
                        matTooltip="Does not include blackout periods."
                        matTooltipPosition="above"
                        matTooltipClass="tooltip"
                      ></i>
                    </div>
                  </div>
                </div>
                } @if (isMessageExpirationType('none')) {
                <div class="message_expiration_disabled">
                  <p class="message_expiration_desc">
                    Set the amount of time until this message is hidden from a
                    Feed.
                  </p>
                </div>
                }
              </div>
            </div>
          </div>
          } @if (message.type === 'MessageSender') {
          <br />
          <div class="form-group child-group">
            <label>{{
              newFeed.enabled ? 'Notification' : 'Text Message'
            }}</label>
            <div class="btn-group pull-right">
              <div
                class="btn btn-sm btn-default"
                [(ngModel)]="message.sms.is_shown"
                (ngModelChange)="toggleSMS()"
                name="sms_is_shown_on"
                ngDefaultControl
                btnRadio="true"
              >
                On
              </div>
              <div
                class="btn btn-sm btn-default"
                [(ngModel)]="message.sms.is_shown"
                (ngModelChange)="toggleSMS()"
                name="sms_is_shown_off"
                ngDefaultControl
                btnRadio="false"
              >
                Off
              </div>
            </div>
            <div class="clearfix"></div>
            @if ( message.sms && message.sms.is_shown === 'true' &&
            currentClient ) {
            <rn-sms-builder
              [smsModel]="message.sms"
              [smsFormGroup]="messageGroup"
              [maxCharacterCount]="currentClient.sms_max_length"
              [wireMessageIsShown]="message.wire.is_shown === 'true'"
              [customInputs]="currentClient.ext_dynamic_fields"
              [contactCardEnabled]="this.contactCardEnabled"
            ></rn-sms-builder>
            } @if ( featureService.checkFlag(featureFlags.throttling) &&
            hasThrottlingPermissions ) {
            <div class="form-group child-group" id="throttling_options">
              <label id="throttling_lbl">Throttling</label>
              <div class="btn-group pull-right">
                <div
                  class="btn btn-sm btn-default"
                  [class.active]="throttlingInfo.throttling === 'default'"
                  (click)="setThrottlingOption('default')"
                  id="default-throttling"
                >
                  default
                </div>
                <div
                  class="btn btn-sm btn-default"
                  [class.active]="throttlingInfo.throttling === 'off'"
                  (click)="setThrottlingOption('off')"
                  id="no-throttling"
                >
                  off
                </div>
                <div
                  class="btn btn-sm btn-default"
                  [class.active]="throttlingInfo.throttling === 'custom'"
                  (click)="setThrottlingOption('custom')"
                  id="custom-throttling"
                >
                  Set custom
                </div>
              </div>
              <div id="throttling_container" class="py-1">
                @if (isMessageThrottlingType('default')) {
                <em
                  class="message-throttling-content"
                  data-testid="default-throttling-content"
                >
                  This notification will follow the global throttling limit in
                  place at the time it's triggered.
                  <strong>
                    {{
                      isMessageThrottlingType('default') &&
                      currentClient?.notification_throttling?.enabled
                        ? 'The current default is ' +
                          (currentClient?.notification_throttling?.max_rate
                            | number) +
                          ' messages per hour.'
                        : 'Global throttling is currently off.'
                    }}
                  </strong>
                </em>
                } @if (isMessageThrottlingType('off')) {
                <em
                  class="message-throttling-content"
                  data-testid="off-throttling-content"
                  >Throttling is <strong>off for this notification.</strong></em
                >
                } @if (isMessageThrottlingType('custom')) {
                <div
                  class="d-flex align-items-center"
                  data-testid="custom-throttling-content"
                >
                  <small class="message-throttling-content">
                    Throttle notifications at this hourly rate:
                  </small>
                  <app-slider-range-input
                    [min]="2500"
                    [max]="50000"
                    [step]="500"
                    [value]="throttlingInfo.maxRate"
                    (valueChange)="onSliderChange($event)"
                    [disabled]="!isMessageThrottlingType('custom')"
                  ></app-slider-range-input>
                </div>
                }
              </div>
            </div>
            }
          </div>
          <br />
          <div class="form-group">
            <div class="blackout">
              <label>Custom Blackout Window</label>
              <div class="blackout_toggles pull-right">
                <div>
                  <div class="btn-group">
                    <div
                      class="btn btn-sm btn-default"
                      [(ngModel)]="message.sms.blackout_settings.blackout_type"
                      name="sms_blackout_default"
                      ngDefaultControl
                      btnRadio="default"
                      id="default-blackout"
                      (click)="setBlackout('default')"
                    >
                      default
                    </div>
                    <div
                      class="btn btn-sm btn-default"
                      [(ngModel)]="message.sms.blackout_settings.blackout_type"
                      name="sms_blackout_default"
                      ngDefaultControl
                      btnRadio="none"
                      (click)="setBlackout('none')"
                      id="no-blackout"
                    >
                      No Blackout
                    </div>
                    <div
                      class="btn btn-sm btn-default"
                      [(ngModel)]="message.sms.blackout_settings.blackout_type"
                      name="sms_blackout_default"
                      ngDefaultControl
                      btnRadio="custom"
                      (click)="setBlackout('custom')"
                      id="custom-blackout"
                    >
                      Set custom
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div
                [class]="
                  'blackout_custom ' +
                  message.sms.blackout_settings.blackout_type
                "
              >
                @if (isBlackoutType('custom') && blackoutWindowExists()) {
                <div>
                  <div class="input-container">
                    <div class="input">
                      <label i18n="Blackout window start label"
                        >Blackout start</label
                      >
                      <select
                        i18n="Blackout window start select"
                        [(ngModel)]="
                          message.sms.blackout_settings.blackout_window
                            .start_time
                        "
                        (ngModelChange)="onCustomBlackoutStartChange()"
                        name="blackout_start"
                        class="form-control"
                        id="custom-blackout-start"
                      >
                        @for (hour of hours; track hour) {

                        <option [attr.value]="hour.isoHour">
                          {{ hour.displayHour }}
                        </option>

                        }
                      </select>
                    </div>
                  </div>
                  <div class="input-container">
                    <div class="input">
                      <label i18n="Blackout window end label"
                        >Blackout end</label
                      >
                      <select
                        i18n="Blackout window end select"
                        [(ngModel)]="
                          message.sms.blackout_settings.blackout_window.end_time
                        "
                        (ngModelChange)="onCustomBlackoutEndChange()"
                        name="blackout_end"
                        class="form-control"
                        id="custom-blackout-end"
                      >
                        @for (hour of hours; track hour) {

                        <option [attr.value]="hour.isoHour">
                          {{ hour.displayHour }}
                        </option>

                        }
                      </select>
                    </div>
                  </div>
                  @if ( weekendSwitchesAreSet() && blackoutWindowExists() ) {
                  <div class="input-container input-container--contains-switch">
                    <div class="input clearfix">
                      <app-radio-btn
                        [btnLabel]="'Blackout on Saturday?'"
                        [btnWidth]="'300px'"
                        [btnName]="'blackout-on-saturday'"
                        [(btnModel)]="
                          message.sms.blackout_settings.blackout_window
                            .include_saturday
                        "
                      ></app-radio-btn>
                    </div>
                  </div>
                  <div class="input-container input-container--contains-switch">
                    <div class="input clearfix">
                      <app-radio-btn
                        [btnLabel]="'Blackout on Sunday?'"
                        [btnWidth]="'300px'"
                        [btnName]="'blackout-on-sunday'"
                        [(btnModel)]="
                          message.sms.blackout_settings.blackout_window
                            .include_sunday
                        "
                      ></app-radio-btn>
                    </div>
                  </div>
                  }
                </div>
                }
                <div class="clearfix"></div>
                @if (isBlackoutType('none')) {
                <p>No Blackout Window will be applied.</p>
                }
                <p></p>
                @if ( blackoutWindowExists() && (isBlackoutType('custom') ||
                isBlackoutType('default')) ) {
                <p>
                  <i id="custom-blackout-desc">
                    Users will only receive notifications from
                    {{
                      clientService.getDisplayHour(
                        message.sms.blackout_settings.blackout_window.end_time
                      )
                    }}
                    until
                    {{
                      clientService.getDisplayHour(
                        message.sms.blackout_settings.blackout_window.start_time
                      )
                    }}
                    Eastern Standard Time. {{ weekendBlackoutMessage }}
                  </i>
                </p>
                } @if (isBlackoutType('custom')) {
                <p>
                  <i i18n="Description for blackout window start/end values">
                    Note: The blackout window start and end times cannot be set
                    equal. Attempting to do so will cause the other to be
                    adjusted by one hour.
                  </i>
                </p>
                <p>
                  <i
                    >Note: Users will not receive messages on Saturday or Sunday
                    when “On” is selected.</i
                  >
                </p>
                }
              </div>
            </div>
          </div>
          }
          <br />
          <div class="form-group">
            <div
              class="row message-footer d-flex justify-content-between align-items-center"
            >
              <div
                class="btn"
                (click)="navigateBackToJourneyBuilder()"
                id="cancel-btn"
              >
                <div class="cancel-mesage">Cancel</div>
              </div>
              <button
                class="btn btn-primary save-mesage"
                (click)="checkInputParams(messageGroup)"
                id="save-btn"
              >
                <div>
                  Save<span class="icon icon-right"
                    ><i class="fa fa-angle-right"></i
                  ></span>
                </div>
              </button>
            </div>
          </div>
        </form>
      </div>
      } @if (contentCreateMode === 'focusAi') {
      <rn-focus-ai
        [messageId]="message.name"
        [emptyMessageContent]="
          message.wire.text === '' && message.wire.actions.length === 0
        "
        [productGroup]="productGroup"
        (cancel)="switchToManualMode()"
        (apply)="applyFocusAiChanges()"
        (focusAiMessage)="onFocusAiMessage($event)"
        (focusAiError)="onFocusAiError($event)"
      ></rn-focus-ai>
      }
    </div>
  </div>
</div>
} @if (showAddAssetDialog) {
<add-media-asset
  [clientId]="this.sessionService.currentUser.client.id"
  [assetTypes]="addMediaAssetType"
  [canSelect]="mediaAssetCanSelect"
  [maxFileSize]="1048576"
  (onSave)="onMediaAssetAdded($event)"
  (onClose)="onCloseAddMediaAssetDialog()"
  (onSelect)="onMediaAssetSelected($event)"
  [createBrand]="createBrand"
>
</add-media-asset>
}

<message-dialog
  #inputWarningMessageDialog
  [showCancel]="true"
  (affirm)="submitForm(messageGroup)"
>
</message-dialog>

<message-dialog
  #messageDialogWithKickback
  (affirm)="navigateBackToJourneyBuilder()"
>
</message-dialog>

<message-dialog #messageDialogNoKickback> </message-dialog>

<message-dialog #iwcuWarning [showCancel]="true" (affirm)="cleanIWCUAndSave()">
</message-dialog>
@if (loaded && message) {
<rn-content-pro-modal
  #contentProModal
  [messageId]="messageId"
  [emptyMessageContent]="!message?.wire?.text"
  [productGroup]="productGroup"
  [clientId]="currentClient?.id"
  [language]="journey?.latestContent?.language"
  (apply)="applyFocusAiChanges()"
  (cancel)="switchToManualMode()"
  (contentProMessage)="onFocusAiMessage($event)"
  (contentProError)="onFocusAiError($event)"
></rn-content-pro-modal>
}
<div class="throttling-dialog">
  <message-dialog
    #editThrottlingConfirmationDialog
    class="align-right-buttons"
    (affirm)="affirmEditThrottling($event)"
    [showCancel]="true"
    [affirmButtonClass]="'btn btn-primary px-2'"
    [affirmButtonText]="'I\'m Sure'"
    [cancelButtonText]="'Cancel'"
  >
    <h5 class="text-left text-dark p-0 font-weight-bold">
      Are you sure you want to change throttling settings for this notification?
    </h5>
    <p class="text-left text-dark p-0 message-throttling-content">
      This will apply to all triggered notifications including the remaining of
      any currently in progress. Setting will not be applied until the
      experience is marked as ‘complete’.
    </p>
  </message-dialog>
</div>
